import * as Yup from 'yup';
import {
  CasButton,
  CasDisplayField,
  CasEditForm,
  CasRHFDropzoneSingleUpload,
  CasStackRow,
} from 'src/compass/shared/components';

const Schema = Yup.object().shape({
  file: Yup.mixed().required('File is required.'),
});

interface Props {
  row?: any;
  onSaved: Function;
}

export default function PublicUploadFileForm({ row, onSaved }: Props) {
  return (
    <CasEditForm
      fileUpload
      defaultValues={row}
      onSaved={onSaved}
      entity="Public/Uploads"
      schema={Schema}
    >
      <CasStackRow className="bordered-cells">
        <CasDisplayField label="Email" value={row?.email} />
      </CasStackRow>
      {row?.hasUpload && (
        <CasStackRow className="bordered-cells">
          <CasDisplayField label="Has Upload" value="Has previous upload" />
        </CasStackRow>
      )}
      <CasStackRow className="bordered-cells">
        <CasDisplayField label="Upload" value={row?.type} />
      </CasStackRow>
      <CasRHFDropzoneSingleUpload name="file" />
      <CasStackRow justifyContent="flex-end">
        <CasButton type="submit">Submit</CasButton>
      </CasStackRow>
    </CasEditForm>
  );
}
